import navigateTo from "src/navigate-to";

// ============================================================================
// NAVIGATION UTILITIES
// ============================================================================

/**
 * Navigate to the appropriate flow view based on appName and flowName
 * If flowName is provided, navigates to the subflow, otherwise navigates to the main app
 *
 * @param appName - The name of the application
 * @param flowName - Optional name of the subflow
 */
export const navigateToFlow = (appName?: string, flowName?: string) => {
    if (appName) {
        if (flowName) {
            navigateTo.Subflow(appName, flowName, false);
        } else {
            navigateTo.App(appName, false);
        }
    }
};

export const navigateToNode = (flowName?: string, appName?: string, nodeName?: string) => {
    if (flowName) {
        navigateTo.EditFlowNode(appName, flowName, nodeName, false);
    } else {
        navigateTo.EditNode(appName, nodeName, false);
    }
};
